import { GlobalOutlined, LockOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

import { ROLE_OPTIONS } from "@/contexts/AssumedRoleContext";

import {
  ALL_ROLES,
  type RoleAccess,
} from "@/views/DocumentWorkspace/documentWorkspaceData";

function labelFor(role: string): string {
  return ROLE_OPTIONS.find((option) => option.key === role)?.label ?? role;
}

/**
 * Which roles may access a document. Enforcement is at the retrieval layer; this reports
 * the rule rather than applying it.
 */
export function RoleAccessBadge({ roleAccess }: { roleAccess: RoleAccess }) {
  const isOpen = roleAccess.length >= ALL_ROLES.length;
  const names = roleAccess.map(labelFor);

  if (isOpen) {
    return (
      <span className="inline-flex h-5 items-center gap-1 rounded-[4px] bg-[#F0F2F4] px-1.5 text-[12px] font-semibold text-[#6B7280]">
        <GlobalOutlined />
        All roles
      </span>
    );
  }

  return (
    <Tooltip title={names.join(" · ")}>
      <span className="inline-flex h-5 items-center gap-1 rounded-[4px] bg-[#FEE2E2] px-1.5 text-[12px] font-semibold text-[#B91C1C]">
        <LockOutlined />
        {names.length === 1 ? names[0] : `${names.length} roles`}
      </span>
    </Tooltip>
  );
}
